import { BaseRouteType, NestedRoutesType } from './BaseRoutes';

export function generateNestedRoute(
  baseRoute: BaseRouteType,
  nestedRoute: NestedRoutesType,
): string {
  return `${baseRoute}/${nestedRoute}`;
}

export function generateNestedRouteWithId(
  baseRoute: BaseRouteType,
  nestedRoute: NestedRoutesType,
  id: string,
): string {
  const idFragment = id ? `/${id}` : '';

  return `${generateNestedRoute(baseRoute, nestedRoute)}${idFragment}`;
}

/**
 * Determines whether a path is the current location, matching on full path
 * segments so sibling routes that share a prefix (ex: `costyoy` and
 * `costyoybar`) are not both treated as active.
 */
export function isPathActive(pathname: string, path: string): boolean {
  if (!pathname || !path) {
    return false;
  }

  const normalizedPath = path.endsWith('/') ? path.slice(0, -1) : path;
  const normalizedPathname = pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;

  return (
    normalizedPathname === normalizedPath ||
    normalizedPathname.startsWith(`${normalizedPath}/`)
  );
}
